import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: 24,
    backgroundColor: themes.light.white[1],
    gap: 16,
  },
  field: {},
  label: {
    marginBottom: 8,
  },
  switchButtonsContainer: {
    flexDirection: 'row',
    width: '100%',
    gap: 4,
    // marginBottom: 3,
  },
  switchButton: {
    width: '50%',
  },
  checkboxContainer: {
    gap: 8,
  },
  checkboxItem: {
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
  },
  footerButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 8,
    width: '100%',
    paddingVertical: 12,
  },
  footerButtonLeft: {
    flex: 1,
    maxWidth: '33%',
  },
  footerButtonRight: {
    flex: 1,
    maxWidth: '67%',
  },
  entryHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 14,
    backgroundColor: themes.light.gray_blue[7],
    borderRadius: 8,
    marginTop: 12,
    marginBottom: 8,
  },
  entryContainer: {
    gap: 8,
    paddingBottom: 16,
  },
  entrySeparator: {
    marginVertical: 16,
  },
  entryHeaderText: {
    color: themes.light.gray_blue[1],
  },
  removeText: {
    color: themes.light.red[4],
  },
});
